export type LngLat = [number, number];

export function decodePolyline(encoded: string, precision: 5 | 6 = 5): LngLat[] {
  let index = 0;
  let lat = 0;
  let lng = 0;
  const coordinates: LngLat[] = [];
  const factor = Math.pow(10, precision);
  let shift: number;
  let result: number;
  let byte: number;

  while (index < encoded.length) {
    shift = 0;
    result = 0;
    do {
      byte = encoded.charCodeAt(index++) - 63;
      result |= (byte & 0x1f) << shift;
      shift += 5;
    } while (byte >= 0x20);
    lat += result & 1 ? ~(result >> 1) : result >> 1;

    shift = 0;
    result = 0;
    do {
      byte = encoded.charCodeAt(index++) - 63;
      result |= (byte & 0x1f) << shift;
      shift += 5;
    } while (byte >= 0x20);
    lng += result & 1 ? ~(result >> 1) : result >> 1;

    coordinates.push([lng / factor, lat / factor]);
  }
  return coordinates;
}
